/**
 * getProductAttributesByFacets
 * Find the product attributes that are configured as a facet
 */ const getProductAttributesByFacets = (facets, attributes, locale)=>{
    if (!facets || facets.length === 0 || !attributes || attributes.length === 0 || !locale) {
        console.error(`Something went wrong trying to match product attributes to facets`);
        return [];
    }
    const facetsToFilter = facets.filter((facet)=>facet.attribute.startsWith('filterableAttributes')
    ).map((facet)=>{
        const attribute = facet.isLocalized ? `${facet.attribute}_${locale}` : facet.attribute;
        return {
            attribute,
            id: facet.id,
            type: facet.type || 'optional'
        };
    });
    return attributes.reduce((prev, attribute)=>{
        const facet1 = facetsToFilter.find((facet)=>facet.id === (attribute.name || attribute.specificationAttribute)
        );
        if (facet1) {
            prev.push({
                id: facet1.attribute,
                value: attribute.value,
                type: facet1.type
            });
        }
        return prev;
    }, []);
};

export { getProductAttributesByFacets };
//# sourceMappingURL=get-product-attributes-from-facets.js.map
